import React from "react";
import PropTypes from "prop-types";
import { LoadScript, StandaloneSearchBox } from "@react-google-maps/api";

/**
 * Keep address forms usable when a deployment has not configured Places yet.
 * Once a key is supplied, preserve the existing Google Maps script contract.
 */
const GoogleMapsProvider = ({
  apiKey,
  libraries = ["places"],
  loadingElement,
  children,
}) => {
  if (!String(apiKey || "").trim()) {
    return <>{children}</>;
  }

  return (
    <LoadScript
      googleMapsApiKey={apiKey}
      libraries={libraries}
      loadingElement={loadingElement}
    >
      {children}
    </LoadScript>
  );
};

const GoogleMapsSearchBox = ({ apiKey, children, ...props }) => {
  if (!String(apiKey || "").trim()) {
    return <>{children}</>;
  }

  return (
    <StandaloneSearchBox {...props}>
      {children}
    </StandaloneSearchBox>
  );
};

GoogleMapsProvider.propTypes = {
  apiKey: PropTypes.string,
  libraries: PropTypes.arrayOf(PropTypes.string),
  loadingElement: PropTypes.node,
  children: PropTypes.node,
};

GoogleMapsSearchBox.propTypes = {
  apiKey: PropTypes.string,
  children: PropTypes.node,
};

export { GoogleMapsSearchBox };
export default GoogleMapsProvider;
